import Component from '../core/Component'
import { toggleClass } from '../utils/dom'

export const STATES = {
    SELECTED: 'is-selected'
}

export default class FilterControl extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            select: null,
            checkbox: null
        }
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)
        this.render()
    }

    handleChange = event => {
        this.render()
    }

    render() {
        let hasValue = false

        if (this.ref.select) {
            hasValue = this.ref.select.value !== ''
        }

        if (this.ref.checkbox) {
            hasValue = this.ref.checkbox.checked
        }

        toggleClass(this.element, STATES.SELECTED, hasValue)
    }
}
